import { GeneralShipmentBookedBy } from "./GeneralShipmentBookedBy";
import { ShipmentDetailShipmentBookedBy } from "./ShipmentDetailShipmentBookedBy";

interface Props {
  shipment: CondensedShipment;
  isShipmentDetailChat: boolean;
}

export function ShipmentBookedBy(props: Props) {
  const { shipment, isShipmentDetailChat } = props;

  if (isShipmentDetailChat) {
    return <ShipmentDetailShipmentBookedBy shipment={shipment} />;
  }

  return <GeneralShipmentBookedBy shipment={shipment} />;
}
